
import { Component, Ref, Vue } from 'vue-property-decorator';

// Components
import VAdministrationMain from '@/components/Administration/VAdministrationMain.vue';
import VAdministrationHeader from '@/components/Administration/VAdministrationHeader.vue';
import VPageTitle from '@/components/Administration/VPageTitle.vue';
import VAdministrationWidget from '@/components/Administration/VAdministrationWidget.vue';
import VAdministrationCityForm from '@/components/Administration/VAdministrationCityForm.vue';

import VBreadcrumbs from '@/components/VBreadcrumbs.vue';
import VPoppedAlert from '@/components/VPoppedAlert.vue';

@Component({
    components: {
        VAdministrationMain,
        VAdministrationHeader,
        VPageTitle,
        VAdministrationWidget,
        VAdministrationCityForm,

        VBreadcrumbs,
        VPoppedAlert,
    },
})
export default class CityCreatePage extends Vue {
    @Ref() public poppedAlert!: VPoppedAlert;

    public showSuccess() {
        this.poppedAlert?.show(this.$t('page.administration.cityCreated'));
    }
}
